import { render, staticRenderFns } from "./RightAdministracao.vue?vue&type=template&id=4f556f1f&scoped=true"
import script from "./RightAdministracao.vue?vue&type=script&lang=js"
export * from "./RightAdministracao.vue?vue&type=script&lang=js"
import style0 from "./RightAdministracao.vue?vue&type=style&index=0&id=4f556f1f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f556f1f",
  null
  
)

export default component.exports